import { createLink } from '@tanstack/react-router';
import { Link as OptimusLink, LinkButton as OptimusLinkButton } from '@optimus-web/core';
import { TooltippedIconButton } from '../tooltip';

export const Link = createLink(OptimusLink);
export const LinkButton = createLink(OptimusLinkButton);
export const LinkIconButton = createLink((props: React.ComponentProps<typeof TooltippedIconButton>) => (
    <TooltippedIconButton {...props} asTag="a" />
));
